import React, { Component } from "react";
import DraggerIcon from "./../icons/draggericon";
import CatEditIcon from "./../icons/catediticon";
import FpgMinusIcon from "./../icons/fpgminusicon";
import TextField from "./../component/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SimpleReactValidator from "simple-react-validator";
import swal from "sweetalert";
import service from "../services";
import Loader from "../component/loader";
import Tablist from "./Tablist";
import commonImage from "../commonImage";
import FpgPlusIcon from "../icons/fpgplusicon";
import PlusIcon from "../icons/plusicon";

let sub;

class EventSponsors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addCatmodal: false,
      imagePreloader: false,
      base64: "",
      getAllSponsorDocs: [],
      name: "",
      description: "",
      isEditMode: false,
      id: "",
      loaderFlag: false,
      isEdited: false,
      errorMsg: false,
      errorMsgShow: "",
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }

  componentDidMount = async () => {
    this.subscribeEvents();
    this.getAllSponsors();
    this.setState({ loaderFlag: true });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  subscribeEvents = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "eventSponsor|getList":
          this.setState(
            {
              getAllSponsorDocs: response.data || [],
              loaderFlag: false,
            },
            () => {
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "eventSponsor|create":
          if (response.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
                loaderFlag: false,
              },
              () => {
                this.resetForm();
                this.apiserve.success("Event sponsor created successfully.");
              }
            );
            this.getAllSponsors();
          }
          break;
        case "eventSponsor|update":
          if (response.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
                loaderFlag: false,
              },
              () => {
                this.resetForm();
                this.apiserve.success("Event sponsor updated successfully.");
              }
            );
            this.getAllSponsors();
          }
          break;
        case "eventSponsor|delete":
          if (!response.error) {
            swal("Your record has been deleted!", { icon: "success" });
            this.getAllSponsors();
          } else {
            this.setState({ errorMsg: true, errorMsgShow: response.data.error || "Delete failed" });
          }
          break;
        case "eventSponsor|changeOrder":
          break;
        default:
          break;
      }
    });
  };

  getAllSponsors = () => {
    this.apiserve.sendevent("eventSponsor|getList", {});
  };

  onInputChange = (e) => {
    this.updateState({ [e.target.name]: e.target.value });
  };

  updateState = (data, callback) => {
    this.setState({ ...data, isEdited: true }, callback);
  };

  resetForm = () => {
    this.setState({
      name: "",
      description: "",
      base64: "",
      id: "",
      isEditMode: false,
      isEdited: false,
    });
    this.validator.hideMessages();
  };

  openAddModal = () => {
    this.resetForm();
    this.setState({ addCatmodal: true });
  };

  CloseModal = () => {
    this.resetForm();
    this.setState({ addCatmodal: false });
  };

  editSponsor = (item) => {
    this.setState({
      addCatmodal: true,
      isEditMode: true,
      name: item.name,
      description: item.description || "",
      base64: item.sponsorImage || "",
      id: item._id,
      isEdited: false,
    });
    this.validator.hideMessages();
  };

  deleteSponsor = (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.apiserve.sendevent("eventSponsor|delete", {
          eventSponsorId: item._id,
        });
      } else {
        swal("Your record is safe!");
      }
    });
  };

  onChangeFile(e) {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({ file }, () => {
        const fileSize = Math.round(file && file.size / 1024);
        if (fileSize >= 2048) {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a file smaller than 2 MB",
          });
          return false;
        }
        if (
          (file && file.type === "image/png") ||
          (file && file.type === "image/jpg") ||
          (file && file.type === "image/jpeg")
        ) {
          setTimeout(() => {
            this.imageUpload(file, event.target.result);
          }, 0);
        } else {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a file for PNG, JPG or JPEG",
          });
        }
      });
    };
  }

  imageUpload = (file, img) => {
    this.setState({ imagePreloader: true });
    const fileSet = commonImage(file, false, "", img);
    fileSet.then((value) => {
      this.updateState({ base64: value, imagePreloader: false });
    });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.isEditMode) {
        this.apiserve.sendevent("eventSponsor|update", {
          eventSponsorId: this.state.id,
          name: this.state.name,
          description: this.state.description,
          sponsorImage: this.state.base64,
        });
      } else {
        this.apiserve.sendevent("eventSponsor|create", {
          name: this.state.name,
          description: this.state.description,
          sponsorImage: this.state.base64,
        });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const arr = [...(this.state.getAllSponsorDocs || [])];
    const newIndex = destination.index;
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k--) arr.push(undefined);
    }
    arr.splice(newIndex, 0, arr.splice(source.index, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({ eventSponsorId: _id, sortIndex: i + 1 });
    });
    this.apiserve.sendevent("eventSponsor|changeOrder", { order: updateArr });
    this.setState({ getAllSponsorDocs: arr });
  };

  validateModel = () => {
    this.setState({ errorMsg: false });
  };

  render() {
    const { getAllSponsorDocs, isEditMode } = this.state;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <Tablist
            active="Event Sponsors"
            name="eventSponsors"
            ref={this.tablistRef}
          />
          <div className="cat_outer_content">
            <div className="category_add_edit">
              <div className="category_header relative d_flex">
                <p>Event Sponsors</p>
                <span
                  className="add_icon d_flex"
                  onClick={this.openAddModal}
                  style={{ cursor: "pointer" }}
                >
                  <FpgPlusIcon
                    width="16"
                    height="16"
                    color="#ffffff"
                    stroke="#4F4F4F"
                  />
                </span>
              </div>
              <div className="list_wrap striped_droppable_table">
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <ul
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {(getAllSponsorDocs || []).map((item, index) => (
                          <Draggable
                            key={item._id}
                            draggableId={item._id}
                            index={index}
                          >
                            {(provided) => (
                              <li
                                className="pointer d_flex d_flex_align_center"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <span className="cat_drag d_flex">
                                  <DraggerIcon />
                                </span>
                                <div className="cat_name d_flex">
                                  <p>{item.name}</p>
                                </div>
                                <div className="action d_flex d_flex_align_center">
                                  <span
                                    className="cat_edit pointer"
                                    onClick={() => this.editSponsor(item)}
                                  >
                                    <CatEditIcon />
                                  </span>
                                  <span
                                    className="remove_cat pointer"
                                    onClick={() => this.deleteSponsor(item)}
                                  >
                                    <FpgMinusIcon
                                      width="16"
                                      height="16"
                                      color="#4F4F4F"
                                    />
                                  </span>
                                </div>
                              </li>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </div>
        </div>

        {/* Create / Edit Modal */}
        <div
          className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
        >
          <span className="popup_overlay" onClick={this.CloseModal}></span>
          <div className="cat_modal_inner">
            <p className="cat_title text_center">
              {isEditMode ? "Edit Event Sponsor" : "Add Event Sponsor"}
            </p>
            <form>
              <div className="field_row horizontal_field d_flex">
                <label>Sponsor Image</label>
                <div className="cat_img_upload">
                  <div className="cat_img radius_50 absolute_loader">
                    {this.state.imagePreloader ? (
                      <Loader />
                    ) : (
                      <img
                        src={
                          this.state.base64
                            ? this.apiserve.imageUrl + this.state.base64
                            : "/images/image-placeholder.png"
                        }
                        alt="sponsor"
                      />
                    )}
                    <div className="input_file">
                      <input
                        id="sponsorImageInput"
                        type="file"
                        ref={(ref) => (this.upload = ref)}
                        style={{ display: "none" }}
                        onChange={this.onChangeFile.bind(this)}
                        accept=".png, .jpg, .jpeg"
                      />
                      <span
                        className="add_icon"
                        onClick={() => this.upload.click()}
                      >
                        <PlusIcon />
                      </span>
                    </div>
                  </div>
                </div>
                <span className="limit_text">2 MB Limit</span>
              </div>
              <div className="field_row horizontal_field d_flex">
                <TextField
                  type="text"
                  label="Sponsor Name"
                  name="name"
                  value={this.state.name}
                  onChange={this.onInputChange}
                  fpgerror={this.validator.message(
                    "Sponsor Name",
                    this.state.name,
                    "required"
                  )}
                />
              </div>
              <div className="field_row horizontal_field d_flex">
                <label>Description</label>
                <div className="textarea_wrap">
                  <textarea
                    rows="6"
                    name="description"
                    value={this.state.description}
                    onChange={this.onInputChange}
                  ></textarea>
                  <span style={{ color: "red" }}>
                    {this.validator.message(
                      "Description",
                      this.state.description,
                      "required"
                    )}
                  </span>
                </div>
              </div>
              <div className="cat_btns text_center">
                <button type="button" onClick={this.CloseModal}>
                  CANCEL
                </button>
                <button
                  className={
                    isEditMode && !this.state.isEdited ? "disabled" : "active"
                  }
                  disabled={isEditMode && !this.state.isEdited}
                  onClick={(e) => this.submitFn(e)}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Error Modal */}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default EventSponsors;
